import type { FinishReason, GameResult, Side, ViewerRole } from "../../shared/game.ts";

export function formatClock(milliseconds: number): string {
  const value = Math.max(0, milliseconds);
  if (value < 10_000) {
    const seconds = Math.floor(value / 1000);
    const tenths = Math.floor((value % 1000) / 100);
    return `0:${seconds.toString().padStart(2, "0")}.${tenths}`;
  }
  const totalSeconds = Math.ceil(value / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}

export function sideLabel(side: Side): string {
  return side === "white" ? "Белые" : "Чёрные";
}

export function resultTitle(result: GameResult | null, viewer: ViewerRole): string {
  if (!result || result === "1/2-1/2") return "Ничья";
  const winner: Side = result === "1-0" ? "white" : "black";
  if (viewer === "spectator") return `${sideLabel(winner)} победили`;
  return viewer === winner ? "Вы победили" : "Соперник победил";
}

export function reasonLabel(reason: FinishReason | null): string {
  const labels: Record<FinishReason, string> = {
    checkmate: "Мат",
    stalemate: "Пат",
    insufficient_material: "Недостаточно фигур для мата",
    threefold_repetition: "Троекратное повторение позиции",
    fifty_move: "Правило пятидесяти ходов",
    agreement: "По соглашению игроков",
    resignation: "Один из игроков сдался",
    timeout: "Время вышло",
    cancelled: "Приглашение в партию отклонено",
  };
  return reason ? labels[reason] : "Партия завершена";
}

export function relativeDate(timestamp: number): string {
  const date = new Date(timestamp);
  const today = new Date();
  if (date.toDateString() === today.toDateString()) {
    return date.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
  }
  return date.toLocaleDateString("ru-RU", { day: "numeric", month: "short" });
}
